export const SEARCH = 'search/SEARCH';
export const SEARCH_SUCCESS = 'search/SEARCH_SUCCESS';
export const SEARCH_ERROR = 'search/SEARCH_ERROR';
